import UploadedImage from '../../classes/UploadedImage';

export default {
    methods: {
        getBase64ForImages(images)
        {
            return new Promise((resolve, reject) => {
                let promises = [];
                for ( let i = 0; i < images.length; i++ ) {
                    promises.push( this.getBase64ForImage(images[i]) );
                }

                Promise.all(promises)
                    .then((images) => resolve(images));
            });
        },

        getBase64ForImage(image)
        {
            return new Promise((resolve, reject) => {
                var reader = new FileReader();
    
                reader.addEventListener("load", (event) => {
                    resolve(event.target.result);
                }); 
                
                reader.readAsDataURL(image);
            });
        },

        async getResizedBase64ForImage(image)
        {
            const processor = new UploadedImage();
            
            return processor.validExtension(image)
                ? processor.get(image)
                : Promise.reject({
                    message: this.$t('form.messages.image_uploader_wrong_image_type')
                });
        }
    }
}